/**
 * The two walking paces (เดินช้า, เดินเร็ว) in a zone that walks (data/zones.ts `walkSpeed`: the demo plaza, Yanyu):
 * both are multiples of the zone's own pace (Model 0's walk gait, about 1.37 m/s): the slow walk about 2 m/s, the fast walk
 * about 3 m/s (the user, 2026-10-08: the real-life paces felt too slow for an open world). The fast walk is the default.
 * Zones that run are unchanged.
 */
export type WalkMode = 'slow' | 'fast';

export const WALK_MODES: Readonly<Record<WalkMode, { readonly label: string; readonly mul: number }>> = {
  slow: { label: 'เดินช้า', mul: 1.46 },
  fast: { label: 'เดินเร็ว', mul: 2.19 },
};

export const DEFAULT_WALK_MODE: WalkMode = 'fast';

export const isWalkMode = (v: unknown): v is WalkMode => v === 'slow' || v === 'fast';

/** A walking zone's pace in walk mode `mode` (absent: the default). */
export const walkPace = (zoneWalk: number, mode: WalkMode | undefined): number =>
  Math.round(zoneWalk * WALK_MODES[mode ?? DEFAULT_WALK_MODE].mul * 1000) / 1000;
